module.exports = __webpack_public_path__ + "img/t4-i23.ea4aa428.svg";